import { __decorate } from "tslib";
import { AfterViewInit, Component, NgZone, OnInit } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { document } from "ngx-bootstrap";
import { WebsiteThemeService } from "../../../services/website-theme.service";
import { Router } from "@angular/router";
import { SharedHttp } from "../../../services/http-client.service";
import { ComponentService } from "../../../services/component.service";
import { RegisterComponent } from "../register.component";
import { LoginComponent } from "../../login";
let EmailGoogleRegistrationComponent = class EmailGoogleRegistrationComponent {
    constructor(sanitizer, themeService, router, httpClient, compService, ngZone) {
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.router = router;
        this.httpClient = httpClient;
        this.compService = compService;
        this.ngZone = ngZone;
        this.textColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.secondColor = '';
        this.errorColor = '';
        this.successColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.emailFormatValid = true;
        this.email = '';
        this.emailExists = false;
        this.submitted = false;
        this.emailValid = false;
        this.providerEmailExists = false;
        this.themeService.getTheme().subscribe((data) => {
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
        });
        const location = window.location;
        this.baseUrl = `${location.protocol}//${location.host}`;
    }
    ngOnInit() {
    }
    close() {
        document.body.className = '';
        this.router.navigateByUrl('/');
        this.modal.destroy();
    }
    ngAfterViewInit() {
        this.initializeGoogleSignIn();
        this.initializeAppleSingIn();
    }
    checkEmail() {
        this.emailExists = false;
        this.emailFormatValid = true;
        if (!this.validateEmail(this.email)) {
            this.emailExists = false;
            this.emailFormatValid = false;
        }
        else {
            return this.httpClient.post('user/checkusername', { username: this.email }).subscribe((data) => {
                this.emailExists = false;
                this.emailFormatValid = true;
                this.emailValid = true;
                this.providerEmailExists = false;
            }, (error) => {
                this.emailExists = true;
                this.emailFormatValid = true;
                this.providerEmailExists = false;
            });
        }
    }
    validateEmail(email) {
        const reg = /^([A-Za-z0-9_\-\.\+])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,15})$/;
        return reg.test(email) !== false;
    }
    initializeGoogleSignIn() {
        google.accounts.id.initialize({
            client_id: localStorage.getItem('google_client_id'),
            callback: (response) => this.handleGoogleCallback(response),
            ux_mode: 'popup',
            context: 'singup',
        });
        this.googleButtonWrapper = this.renderGoogleSingInButton();
    }
    renderGoogleSingInButton() {
        const googleLoginWrapper = document.querySelector('#google-btn-login');
        google.accounts.id.renderButton(googleLoginWrapper, {
            type: 'icon',
            width: '200',
        });
        const googleLoginWrapperButton = googleLoginWrapper.querySelector('div[role=button]');
        return {
            click: () => {
                googleLoginWrapperButton.click();
            },
        };
    }
    handleGoogleSingIn() {
        this.googleButtonWrapper.click();
    }
    googleRegisterCallback(response) {
        this.submitted = true;
        this.providerEmailExists = false;
        this.provider = 'google';
        this.httpClient.post('user/registration/check-external', {
            credential: response.credential,
            provider: this.provider
        }).subscribe(data => {
            const email = data['email'];
            this.httpClient.post('user/checkusername', { username: email }).subscribe(() => {
                this.emailExists = false;
                this.close();
                this.compService.openModal(RegisterComponent, {
                    provider: this.provider,
                    providerToken: response.credential,
                    email
                });
            }, (error) => {
                this.submitted = false;
                this.providerEmailExists = true;
                this.emailExists = false;
            });
        });
    }
    goToRegularRegistrationScreen() {
        this.submitted = true;
        this.close();
        this.compService.openModal(RegisterComponent, {
            providerToken: null,
            email: this.email,
        });
    }
    handleGoogleCallback(response) {
        this.ngZone.run(() => {
            this.googleRegisterCallback(response);
        });
    }
    initializeAppleSingIn() {
        AppleID.auth.init({
            clientId: localStorage.getItem('apple_service_id'),
            scope: 'name email',
            usePopup: true,
            redirectURI: `${this.baseUrl}`,
        });
    }
    handleAppleSignIn() {
        AppleID.auth.signIn().then(response => {
            this.submitted = true;
            this.providerEmailExists = false;
            this.provider = 'apple';
            this.httpClient.post('user/registration/check-external', {
                credential: response.authorization.id_token,
                provider: this.provider
            }).subscribe(data => {
                const email = data['email'];
                this.httpClient.post('user/checkusername', { username: email }).subscribe(() => {
                    this.emailExists = false;
                    this.close();
                    this.compService.openModal(RegisterComponent, {
                        provider: this.provider,
                        providerToken: response.authorization.code,
                        email
                    });
                }, (error) => {
                    this.submitted = false;
                    this.providerEmailExists = true;
                    this.emailExists = false;
                });
            });
        });
    }
    alreadyHave() {
        this.modal.destroy();
        this.compService.openModal(LoginComponent);
    }
};
EmailGoogleRegistrationComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: Router },
    { type: SharedHttp },
    { type: ComponentService },
    { type: NgZone }
];
EmailGoogleRegistrationComponent = __decorate([
    Component({
        selector: 'ecd-email-google-registration',
        template: __importDefault(require("./email-google-registration.component.html")).default,
    })
], EmailGoogleRegistrationComponent);
export { EmailGoogleRegistrationComponent };
